// Мелкие DOM-помощники, не зависящие от состояния приложения.

import { createIcons, icons } from 'lucide';

export function icon(name: string): string {
  return `<i data-lucide="${name}" aria-hidden="true"></i>`;
}

export function refreshIcons(root: Element | Document | DocumentFragment = document): void {
  createIcons({ icons, attrs: { 'aria-hidden': 'true', focusable: 'false' }, root });
}

export function removeEmptyKpiIcons(root: Element | Document | DocumentFragment = document): void {
  root.querySelectorAll?.('.kpi-icon').forEach((node) => {
    if (!node.querySelector('svg')) node.remove();
  });
}

export function escapeHtml(value: string): string {
  return value.replace(/[&<>'"]/g, (character) => {
    const entities: Record<string, string> = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;',
    };
    return entities[character] ?? character;
  });
}
